import { render, staticRenderFns } from "./ApplicationUserMenu.vue?vue&type=template&id=20f01142"
import script from "./ApplicationUserMenu.vue?vue&type=script&lang=js"
export * from "./ApplicationUserMenu.vue?vue&type=script&lang=js"
import style0 from "./ApplicationUserMenu.vue?vue&type=style&index=0&id=20f01142&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports